import * as moment from 'moment';

export enum PaymentStatus {
    pending = 'pending',
    successful = 'successful',
    failed = 'failed'
}

export class UserTicketPayment {
    status: PaymentStatus;
    amount: number;
    created: Date;
    updated?: Date;
    currency?: string;
    actionCode?: string;
    actionCodeDescription?: string;
}

export class UserTicketTripPass {
    qrCode: string;
    cost: number;
    validFrom: Date;
    validTo: Date;
    created: Date;
    updated?: Date;
    isUsed?: boolean;
    isExpired?: boolean;
    usedStatusChangeDate?: Date;
    usedStatusTramInfo?: string;

    public get isRecentlyUsed(): boolean {
        return this.isUsed && this.usedStatusChangeDate 
            && Math.abs(moment(this.usedStatusChangeDate).diff(new Date(), 'hour')) <= 1;
    }

    public get isExpiredNow(): boolean {
        return this.isExpired || moment(this.validTo).isBefore(new Date());
    }

    public get isActive(): boolean {
        return !this.isUsed && !this.isExpiredNow;
    }
}

export class UserTicketTrip {
    id: string;
    pass: UserTicketTripPass;
    created: Date;
    updated?: Date;
}

export enum TicketStatus {
    inactive = 'inactive',
    active = 'active',
    used = 'used'
}

export class UserTicket {
    id: string;
    created: Date;
    updated?: Date;
    tripsCount: number;
    remainingTripsCount: number;
    cost: number;
    orderNumber: number;
    status: TicketStatus;
    payment: UserTicketPayment;
    trips: UserTicketTrip[];
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/userTicket.ts